<p-dialog
  class="dialog"
  [(visible)]="isDisplayed"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()">
  <div class="layout__inner-card mb-5">
    <em-profile-decision-popup-header></em-profile-decision-popup-header>

    <p i18n class="mb-3"
      >Date : <strong>{{ refusalTimestamp }}</strong></p
    >
    @for (header of headers; track header; let last = $last) {
      <p [ngClass]="{'mb-0': !last}">{{ header | emTranslate: _info.languageCode }}</p>
    }
    @for (preInputParagraph of preInputParagraphs; track preInputParagraph) {
      <p>{{ preInputParagraph | emTranslate: _info.languageCode }}</p>
    }

    <div class="flex align-items-baseline gap-3">
      <p class="text-600">{{ _info.languageCode === 'en' ? 'Template:' : 'Modèle :' }}</p>
      <p-dropdown
        class="w-4"
        [options]="dropdownOptions | emTranslate: _info.languageCode"
        [placeholder]="_info.languageCode === 'en' ? 'None' : 'Aucun'"
        [formControl]="dropdownForm"
        optionLabel="name"
        optionValue="value"></p-dropdown>
    </div>

    <textarea [formControl]="form" class="w-full my-3" rows="7" [maxlength]="5000" pInputTextarea></textarea>

    @for (postInputParagraph of postInputParagraphs; track postInputParagraph) {
      <p>{{ postInputParagraph | emTranslate: _info.languageCode }}</p>
    }
  </div>

  <p-button
    (onClick)="submit()"
    [disabled]="form.invalid"
    [loading]="isLoading"
    class="justify-content-center flex"
    icon="pi pi-check"
    i18n-label
    label="Envoyer le courriel au client"></p-button>
</p-dialog>
